var scope_0 = require('/Users/joeloliveira/Development/WWW/Projects/notificare-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
var scope_1 = require('/Users/joeloliveira/Development/WWW/Projects/notificare-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/392ce271798aa240f535f095fac71cea.js').default;
var scope_2 = require('/Users/joeloliveira/Development/WWW/Projects/notificare-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4592d2e5471f13adc4f53594986a3a53.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    